import "./customerview.css"
import personone from "../../img/p1.png"
import persontwo from "../../img/p2.png"
import personthree from "../../img/p3.png"
import personfour from "../../img/p4.png"
import personfive from "../../img/p5.png"
import personsix from "../../img/p6.png"
function Customerview(){
    return(
        <>
        <div className="customerview">
            <div className="start">
                       <h4>Customers View </h4>
                       <div className="point">
                           <div></div>
                           <div></div>
                           <div></div>
                       </div>
            </div>
            <div className="row">
       {/* Person 1 */}
<div className="col-md-6">
  <div className="person card p-4 shadow-sm">
    <div className="d-flex align-items-center mb-3">
      <div className="image me-3">
        <img src={personone} alt="profile" className="rounded-circle" width="80" height="80" />
      </div>
      <div className="text">
        <h4 className="mb-1">Alexandra Della</h4>
        <h6 className="mb-0"><i className="fa-solid fa-envelope me-2"></i>alex@example.com</h6>
      </div>
    </div>

    <div className="boxes d-flex justify-content-between text-center mb-4">
      <div className="box">
        <h5>28.65K</h5>
        <small><i className="fa-solid fa-users me-1"></i>Followers</small>
      </div>
      <div className="box">
        <h5>38.85K</h5>
        <small><i className="fa-solid fa-user-plus me-1"></i>Following</small>
      </div>
      <div className="box">
        <h5>43.67K</h5>
        <small><i className="fa-solid fa-chart-line me-1"></i>Engagements</small>
      </div>
    </div>

    <div className="information">
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-location-dot me-2 text-primary"></i>
        <span>New York, USA</span>
      </div>
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-phone me-2 text-success"></i>
        <span>+1 234 567 890</span>
      </div>
      <div className="d-flex align-items-center">
        <i className="fa-solid fa-envelope me-2 text-danger"></i>
        <span>alex@example.com</span>
      </div>
    </div>

    <div className="buttons">
      <button className="btn btn-danger w-100 mt-1">Delete</button>
      <button className="btn btn-primary w-100 mt-1">Edit Profile</button>
    </div>
  </div>
</div>

{/* Person 2 */}
<div className="col-md-6">
  <div className="person card p-4 shadow-sm">
    <div className="d-flex align-items-center mb-3">
      <div className="image me-3">
        <img src={persontwo} alt="profile" className="rounded-circle" width="80" height="80" />
      </div>
      <div className="text">
        <h4 className="mb-1">Michael Brown</h4>
        <h6 className="mb-0"><i className="fa-solid fa-envelope me-2"></i>michael@example.com</h6>
      </div>
    </div>

    <div className="boxes d-flex justify-content-between text-center mb-4">
      <div className="box">
        <h5>18.20K</h5>
        <small><i className="fa-solid fa-users me-1"></i>Followers</small>
      </div>
      <div className="box">
        <h5>12.40K</h5>
        <small><i className="fa-solid fa-user-plus me-1"></i>Following</small>
      </div>
      <div className="box">
        <h5>30.10K</h5>
        <small><i className="fa-solid fa-chart-line me-1"></i>Engagements</small>
      </div>
    </div>

    <div className="information">
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-location-dot me-2 text-primary"></i>
        <span>London, UK</span>
      </div>
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-phone me-2 text-success"></i>
        <span>+44 123 456 789</span>
      </div>
      <div className="d-flex align-items-center">
        <i className="fa-solid fa-envelope me-2 text-danger"></i>
        <span>michael@example.com</span>
      </div>
    </div>

    <div className="buttons">
      <button className="btn btn-danger w-100 mt-1">Delete</button>
      <button className="btn btn-primary w-100 mt-1">Edit Profile</button>
    </div>
  </div>
</div>

{/* Person 3 */}
<div className="col-md-6">
  <div className="person card p-4 shadow-sm">
    <div className="d-flex align-items-center mb-3">
      <div className="image me-3">
        <img src={personthree} alt="profile" className="rounded-circle" width="80" height="80" />
      </div>
      <div className="text">
        <h4 className="mb-1">Sarah Johnson</h4>
        <h6 className="mb-0"><i className="fa-solid fa-envelope me-2"></i>sarah@example.com</h6>
      </div>
    </div>

    <div className="boxes d-flex justify-content-between text-center mb-4">
      <div className="box">
        <h5>45.80K</h5>
        <small><i className="fa-solid fa-users me-1"></i>Followers</small>
      </div>
      <div className="box">
        <h5>20.15K</h5>
        <small><i className="fa-solid fa-user-plus me-1"></i>Following</small>
      </div>
      <div className="box">
        <h5>50.22K</h5>
        <small><i className="fa-solid fa-chart-line me-1"></i>Engagements</small>
      </div>
    </div>

    <div className="information">
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-location-dot me-2 text-primary"></i>
        <span>Toronto, Canada</span>
      </div>
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-phone me-2 text-success"></i>
        <span>+1 987 654 321</span>
      </div>
      <div className="d-flex align-items-center">
        <i className="fa-solid fa-envelope me-2 text-danger"></i>
        <span>sarah@example.com</span>
      </div>
    </div>

    <div className="buttons">
      <button className="btn btn-danger w-100 mt-1">Delete</button>
      <button className="btn btn-primary w-100 mt-1">Edit Profile</button>
    </div>
  </div>
</div>

{/* Person 4 */}
<div className="col-md-6">
  <div className="person card p-4 shadow-sm">
    <div className="d-flex align-items-center mb-3">
      <div className="image me-3">
        <img src={personfour} alt="profile" className="rounded-circle" width="80" height="80" />
      </div>
      <div className="text">
        <h4 className="mb-1">David Wilson</h4>
        <h6 className="mb-0"><i className="fa-solid fa-envelope me-2"></i>david@example.com</h6>
      </div>
    </div>

    <div className="boxes d-flex justify-content-between text-center mb-4">
      <div className="box">
        <h5>9.50K</h5>
        <small><i className="fa-solid fa-users me-1"></i>Followers</small>
      </div>
      <div className="box">
        <h5>5.70K</h5>
        <small><i className="fa-solid fa-user-plus me-1"></i>Following</small>
      </div>
      <div className="box">
        <h5>12.33K</h5>
        <small><i className="fa-solid fa-chart-line me-1"></i>Engagements</small>
      </div>
    </div>

    <div className="information">
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-location-dot me-2 text-primary"></i>
        <span>Sydney, Australia</span>
      </div>
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-phone me-2 text-success"></i>
        <span>+61 456 789 123</span>
      </div>
      <div className="d-flex align-items-center">
        <i className="fa-solid fa-envelope me-2 text-danger"></i>
        <span>david@example.com</span>
      </div>
    </div>

    <div className="buttons">
      <button className="btn btn-danger w-100 mt-1">Delete</button>
      <button className="btn btn-primary w-100 mt-1">Edit Profile</button>
    </div>
  </div>
</div>

{/* Person 5 */}
<div className="col-md-6">
  <div className="person card p-4 shadow-sm">
    <div className="d-flex align-items-center mb-3">
      <div className="image me-3">
        <img src={personfive} alt="profile" className="rounded-circle" width="80" height="80" />
      </div>
      <div className="text">
        <h4 className="mb-1">Emily Clark</h4>
        <h6 className="mb-0"><i className="fa-solid fa-envelope me-2"></i>emily@example.com</h6>
      </div>
    </div>

    <div className="boxes d-flex justify-content-between text-center mb-4">
      <div className="box">
        <h5>60.10K</h5>
        <small><i className="fa-solid fa-users me-1"></i>Followers</small>
      </div>
      <div className="box">
        <h5>41.25K</h5>
        <small><i className="fa-solid fa-user-plus me-1"></i>Following</small>
      </div>
      <div className="box">
        <h5>75.90K</h5>
        <small><i className="fa-solid fa-chart-line me-1"></i>Engagements</small>
      </div>
    </div>

    <div className="information">
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-location-dot me-2 text-primary"></i>
        <span>Berlin, Germany</span>
      </div>
      <div className="d-flex align-items-center mb-2">
        <i className="fa-solid fa-phone me-2 text-success"></i>
        <span>+49 321 654 987</span>
      </div>
      <div className="d-flex align-items-center">
        <i className="fa-solid fa-envelope me-2 text-danger"></i>
        <span>emily@example.com</span>
      </div>
    </div>

    <div className="buttons">
      <button className="btn btn-danger w-100 mt-1">Delete</button>
      <button className="btn btn-primary w-100 mt-1">Edit Profile</button>
    </div>
  </div>
</div>


            </div>
            <hr />
            <div className="row">
                <div className="col-md-12">
                    <div className="header d-flex justify-content-between align-items-center">
                        <h4>social Media</h4>
<i class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                    
                </div>
      <div className="col-md-12">

  {/* Facebook */}
  <div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
    <div>
      <a href="#" className="text-primary fs-5 me-2">
        <i className="fa-brands fa-facebook"></i>
      </a>
      <span>https://facebook.com/theme_ocean</span>
    </div>
  </div>

  {/* GitHub */}
  <div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
    <div>
      <a href="#" className="text-dark fs-5 me-2">
        <i className="fa-brands fa-github"></i>
      </a>
      <span>https://github.com/theme_ocean</span>
    </div>
  </div>

  {/* LinkedIn */}
  <div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
    <div>
      <a href="#" className="text-primary fs-5 me-2">
        <i className="fa-brands fa-linkedin"></i>
      </a>
      <span>https://linkedin.com/in/theme_ocean</span>
    </div>
  </div>

  {/* YouTube */}
  <div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
    <div>
      <a href="#" className="text-danger fs-5 me-2">
        <i className="fa-brands fa-youtube"></i>
      </a>
      <span>https://youtube.com/@theme_ocean</span>
    </div>
  </div>

  {/* Twitter */}
  <div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
    <div>
      <a href="#" className="text-info fs-5 me-2">
        <i className="fa-brands fa-twitter"></i>
      </a>
      <span>https://twitter.com/theme_ocean</span>
    </div>
  </div>

  {/* Instagram */}
  <div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
    <div>
      <a href="#" className="text-danger fs-5 me-2">
        <i className="fa-brands fa-instagram"></i>
      </a>
      <span>https://instagram.com/theme_ocean</span>
    </div>
  </div>

  {/* WhatsApp */}
  <div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
    <div>
      <a href="#" className="text-success fs-5 me-2">
        <i className="fa-brands fa-whatsapp"></i>
      </a>
      <span>https://wa.me/201234567890</span>
    </div>
  </div>

</div>


            </div>
            <hr />
            <div className="row">
                <div className="col-md-12">
                    <div className="suggesstion mt-2 d-flex justify-content-between align-items-center">
                        <h4>Suggestions</h4>
<i class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                    
                </div>
      <div className="col-md-12">

 

 {/* Person 1 */}
<div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
  <div className="d-flex align-items-center gap-3">
    <div className="image">
      <img src={personone} alt="" width="50" height="50" className="rounded-circle" />
    </div>
    <div className="text">
     <h6 >Michael Brown</h6>
      <small >UI/UX Designer</small>
    </div>
  </div>
  <i className="fa-solid fa-user text-primary"></i>
</div>

{/* Person 2 */}
<div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
  <div className="d-flex align-items-center gap-3">
    <div className="image">
      <img src={persontwo} alt="" width="50" height="50" className="rounded-circle" />
    </div>
    <div className="text">
      <h6 className="mb-0">Michael Brown</h6>
      <small >UI/UX Designer</small>
    </div>
  </div>
  <i className="fa-solid fa-user-tie text-success"></i>
</div>

{/* Person 3 */}
<div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
  <div className="d-flex align-items-center gap-3">
    <div className="image">
      <img src={personthree} alt="" width="50" height="50" className="rounded-circle" />
    </div>
    <div className="text">
      <h6 className="mb-0">Sarah Johnson</h6>
      <small >Full Stack Developer</small>
    </div>
  </div>
  <i className="fa-solid fa-code text-danger"></i>
</div>

{/* Person 4 */}
<div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
  <div className="d-flex align-items-center gap-3">
    <div className="image">
      <img src={personfour} alt="" width="50" height="50" className="rounded-circle" />
    </div>
    <div className="text">
      <h6 className="mb-0">David Wilson</h6>
      <small >Back End Developer</small>
    </div>
  </div>
  <i className="fa-solid fa-database text-warning"></i>
</div>

{/* Person 5 */}
<div className="socialmedia d-flex align-items-center justify-content-between mb-2 p-2 border rounded">
  <div className="d-flex align-items-center gap-3">
    <div className="image">
      <img src={personfive} alt="" width="50" height="50" className="rounded-circle" />
    </div>
    <div className="text">
      <h6 className="mb-0">Emily Clark</h6>
      <small >Project Manager</small>
    </div>
  </div>
  <i className="fa-solid fa-briefcase text-info"></i>
</div>


</div>


            </div>
                   
        </div>
        </>
    )
}
export default  Customerview